import { FetchMinMaxPricesByPositionIdDataProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/RequestTeamMemberView/contexts/FetchMinMaxPricesByPositionId.data.context';
import { FetchTeamMembersDataProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/RequestTeamMemberView/contexts/FetchTeamMembers.data.context';
import { RequestTeamMemberViewPropsProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/RequestTeamMemberView/contexts/RequestTeamMemberView.props.context';
import { RequestTeamMemberViewComponent } from 'modals/ShiftModal/src/views/SendToAgenciesView/RequestTeamMemberView/RequestTeamMemberView.component';
import { FetchSelectedAgenciesRateDataProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/AgencyRequests/FetchSelectedAgenciesRate.data.context';
import { FC } from 'react';
import { withMemo } from 'utils/withMemo';

const _RequestTeamMemberView_: FC = () => {
  return (
    <FetchTeamMembersDataProvider>
      <FetchMinMaxPricesByPositionIdDataProvider>
        <FetchSelectedAgenciesRateDataProvider>
          <RequestTeamMemberViewPropsProvider>
            <RequestTeamMemberViewComponent />
          </RequestTeamMemberViewPropsProvider>
        </FetchSelectedAgenciesRateDataProvider>
      </FetchMinMaxPricesByPositionIdDataProvider>
    </FetchTeamMembersDataProvider>
  );
};
export const RequestTeamMemberView = withMemo(_RequestTeamMemberView_);
